export const SEND_PATTERN_OPTIONS = [
  { value: 0, label: "不可" },
  { value: 1, label: "自動FAX" },
  { value: 3, label: "JCA" },
  { value: 4, label: "WEB-EDI" },
  { value: 5, label: "流通BMS" },
  { value: 6, label: "YHBB" },
] as const;

const SEND_PATTERN_TEXT_MAP: Record<number, string> = Object.fromEntries(
  SEND_PATTERN_OPTIONS.map((o) => [o.value, o.label]),
);

export const getSendPatternText = (sendPattern: number): string =>
  SEND_PATTERN_TEXT_MAP[sendPattern] ?? "";
